<template>
  <div class="basic-container">
    <div class="color-bg-fff padding-20">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'basicContainer',
    props: {
      radius: {
        type: [String, Number],
        default: 10
      },
      background: {
        type: String
      },
      block: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      styleName() {
        return {
          borderRadius: this.setPx(this.radius),
          background: this.background
        }
      }
    }
  }
</script>

<style lang="scss">
  .basic-container {
    padding: 16px;
    box-sizing: border-box;
    background: #f0f2f5;
    min-height: calc(100vh - 96px);
  }
</style>
